import React from 'react'
import * as classes from './Finance.module.scss'
import IconPdf from './IconPdf'
import IconWord from './IconWord'
import IconPpt from './IconPpt'
import { Button } from '../../ui/Button/Button'
import { getFileType, getFileTypeLabel, getFileDownloadLabel } from '../../../utils/getFileType'

const fileIcons = {
    pdf: IconPdf,
    word: IconWord,
    ppt: IconPpt
}

function Item({ title, value, onFormatBytes, lang }) {
    return (
        <div className={classes.Item}>
            <span className={classes.ItemTitle}>{title}</span>

            <div>
                {value.map((file, fileInex) => {
                    const fileType = getFileType(file?.file?.mimeType, file?.file?.url)
                    const FileIcon = fileIcons['word']

                    return (
                        <div className={classes.File} key={fileInex}>
                            <div className={classes.IconPdfWrap}>
                                <FileIcon />
                            </div>

                            <div className={classes.FileContent}>
                                {file?.name && <div className={classes.FileText} dangerouslySetInnerHTML={{ __html: file.name }} />}

                                {file?.file?.size && (
                                    <span className={classes.FileSize}>
                                        {getFileTypeLabel(fileType)}, {onFormatBytes(file.file.size)} Mb
                                    </span>
                                )}

                                {file?.description && <div className={classes.FileDescription} dangerouslySetInnerHTML={{ __html: file.description }} />}
                            </div>

                            <Button
                                className={classes.FileBtn}
                                onClick={() => window.open(file?.file?.url, '_blank', 'noopener,noreferrer')}
                            >
                                {file?.downloadText || getFileDownloadLabel(fileType, lang)}
                            </Button>
                        </div>
                    )
                })}
            </div>
        </div>
    )
}

export default Item
